import React from "react";
import Icon from "../AppIcon";
import Button from "./Button";

interface ModalProps {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	description?: string;
	children: React.ReactNode;
	size?: "sm" | "md" | "lg" | "xl";
}

const Modal: React.FC<ModalProps> = ({
	isOpen,
	onClose,
	title,
	description,
	children,
	size = "md",
}) => {
	if (!isOpen) return null;

	const sizeClasses = {
		sm: "max-w-md",
		md: "max-w-lg",
		lg: "max-w-2xl",
		xl: "max-w-4xl",
	};

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
			<div
				className={`bg-card border border-border rounded-lg shadow-xl w-full ${sizeClasses[size]} max-h-[90vh] overflow-y-auto`}
			>
				{/* Header */}
				<div className="sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between">
					<div>
						<h2 className="text-xl font-bold text-foreground">{title}</h2>
						{description && (
							<p className="text-sm text-muted-foreground mt-1">{description}</p>
						)}
					</div>
					<button
						onClick={onClose}
						className="text-muted-foreground hover:text-foreground smooth-transition"
					>
						<Icon name="X" size={24} />
					</button>
				</div>

				{/* Content */}
				<div className="p-6">{children}</div>
			</div>
		</div>
	);
};

export default Modal;
